import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AutoTradePanel from '../components/AutoTradePanel';
import { useAuth } from '../context/AuthContext';
import { useAutoTrade } from '../hooks/useAutoTrade';

const AutoTradePage = () => {
  const { user, hasActiveSubscription } = useAuth();
  const trade = useAutoTrade({ user, hasActiveSubscription });

  return (
    <div className="min-h-screen flex flex-col bg-[#eef0f5]">
      <Navbar />
      {/* Match Navbar: px-4 lg:px-8 then max-w-7xl mx-auto (same as nav inner). Card is full width of that column so edges line up with logo → profile row; responsive on small screens. */}
      <main className="flex-1 w-full px-4 lg:px-8 py-10 md:py-14 flex flex-col">
        <div className="w-full max-w-7xl mx-auto flex-1 flex flex-col justify-center min-h-0">
          <AutoTradePanel {...trade} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AutoTradePage;
